/*
 * The following code is intended to override some basic functionality of
 * fetch; this allows us to deprecate the middletier service.
 */

// @note: monkey patching the window's implementation of fetch; so we can intercept requests that

const stlSettingUrlsByEnvironment = {
    'Int': 'https://stl-settings.int-sinclairstoryline.com',
    'Qa': 'https://stl-settings.qa-sinclairstoryline.com',
    'Prod': 'https://stl-settings.sinclairstoryline.com',
};

const {fetch: originalFetch} = window;
/**
 * Definition of fetch function
 *
 * @param {string} resource
 * @param {?Object} [config={}]
 * @returns {Promise<Response>}
 */
window.fetch = function fetch(resource, config = {}) {
    let url = resource;

    if (!(url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//'))) {
        // take the url, make sure it has a leading slash
        url = url.replace(/^\/?(api\/.*)$/, `/$1`);
        // if the url includes /api/facade, convert it to /api/rest/facade
        url = url.replace(/^\/api\/facade/, '/api/rest/facade');
        // if the url includes /api but not /api/rest, convert it to /api/rest/facade
        url = url.replace(/^\/api(?!\/rest)/, '/api/rest/facade');

        // if we have facade_ in the url, change all '_' to '/'
        // todo: fix this to limit it to the pathname
        if (url.includes('facade_')) {
            url = url.replace(/_/g, '/');
        }
    }

    /* global globalThis */
    if (resource.includes('stl-settings.local')) {
        const _url = new URL(resource);
        _url.origin = stlSettingUrlsByEnvironment[globalThis.frontendStoryLineConfig.environment];

        return originalFetch(
            _url.href,
            config
        );
    }

    return originalFetch(url, config);
};
